import React from 'react';
import '../user/AboutPAPT.css';  // Import the corresponding CSS file for styling

const transport = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>OUR TRANSPORTATION</h1>
        <div className="yellow-line1"></div>
        <p>
        

College bus facility is available for students who commute daily. The transport department runs 20 buses to various routes in Mangalore, Surathkal and Kasargod region and ensures safe and hassle free transport to all students and staff. The facility is made available to the students at reasonable charges depending upon routes and pickup/drop points opted by them. The students have to register for the transport facility at the time of admission and renew the same every year. Separate bus facility for girls is available for their safe and comfortable travel.

        </p>
       
      </div>
      <div className="ed">
        <img src="/images/IMG_0103.jpg" />
      </div>
    </div>
  );
};

export default transport;
